import {VehicleForm as VFKit} from '../VehicleForm';

export function EngineInfoGroup() {
  return (
    <>
      <VFKit.SimpleTextField name="engineName" />
      <VFKit.SimpleTextField name="engineNumber" />
      <VFKit.SimpleTextField name="engineCode" />
      <VFKit.SimpleNumericField name="maxTorque" />
      <VFKit.SimpleTextField name="transmissionNumber" />
      <VFKit.SimpleTextField name="transmissionCode" />
    </>
  );
}
